"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Field_1 = require("../../constants/Field");
var DataItem_1 = require("../common/base/DataItem");
var MappedType = /** @class */ (function () {
    function MappedType(id, state, model) {
        this.id = id;
        this.state = state;
        this.model = model;
    }
    MappedType.fromJson = function (id, json) {
        if (id === '') {
            throw new Error('Id cannot be empty');
        }
        if (!json[Field_1.FIELD.STATE]) {
            throw new Error('State field in json cannot be undefined');
        }
        var mappedType = new MappedType(id, DataItem_1.DataItem.fromJson(Field_1.FIELD.STATE, json[Field_1.FIELD.STATE]), DataItem_1.DataItem.fromJson(Field_1.FIELD.MODEL, json[Field_1.FIELD.MODEL]));
        return mappedType;
    };
    MappedType.prototype.toJson = function () {
        var json = Object.create(null);
        if ((!this.id) || (!this.state)) {
            throw new Error('Id or state cannot be undefined');
        }
        if (this.id === '') {
            throw new Error('Id cannot be empty');
        }
        var stateJson = Object.create(null);
        stateJson[Field_1.FIELD.STATE] = this.state.toJson(false);
        var mappedTypeDetails = Object.create(null);
        mappedTypeDetails = Object.assign(mappedTypeDetails, stateJson);
        if (this.model) {
            var modelJson = Object.create(null);
            modelJson[Field_1.FIELD.MODEL] = this.model.toJson(false);
            mappedTypeDetails = Object.assign(mappedTypeDetails, modelJson);
        }
        json[this.id] = mappedTypeDetails;
        return json;
    };
    return MappedType;
}());
exports.MappedType = MappedType;
//# sourceMappingURL=MappedType.js.map